export default __webpack_public_path__ + "static/media/Contacts-empty-state.bc27e95c.svg";